@if (demo.isActive) {
<div class="row mb-n3">
    <div class="col-12 col-md-4 mb-3">
        <app-kpi-card [label]="texts.matches | localize">
            {{ kpis.matches | number }}
        </app-kpi-card>
    </div>
    <div class="col-12 col-md-4 mb-3">
        <app-kpi-card [label]="texts.switchSignals | localize">
            {{ kpis.switchSignals | number }}
        </app-kpi-card>
    </div>
    <div class="col-12 col-md-4 mb-3">
        <app-kpi-card [label]="texts.contacted | localize">
            {{ kpis.contacted | number }}
        </app-kpi-card>
    </div>
</div>

<div class="card mt-4">
    <div class="card-header">
        <h5 class="card-title">{{ texts.matchingTalents | localize }}</h5>
    </div>
    <div class="card-body card-body-list">
        <div class="list-group">
            <a class="list-group-item list-group-item-action" routerLink="/candidates/{{ m.Id }}" *ngFor="let m of matches">
                <div class="row align-items-center">

                    <div class="col-auto">
                        <sc-avatar [user]="m" size="sm"></sc-avatar>
                    </div>

                    <div class="col col-shrink ms-n2">
                        <div class="fw-bold mb-0">{{ m.FirstName }} {{ m.LastName }}</div>
                        <p class="small text-muted mb-0 fw-normal oneline">{{ m.JobTitle }} @ {{ m.Company }}</p>
                        <p class="small mb-0 fw-normal">
                            <i class="fa-sharp fa-solid fa-list-check me-1"></i>
                            {{ m.MustHavesMet }}/{{ m.MustHavesTotal }} {{ texts.mustHavesMet | localize }}.
                            @if (m.MustHavesMet < m.MustHavesTotal) {
                            {{ m.MissingMustHaves.join(', ') }} {{ texts.notMet | localize }}.
                            }
                        </p>
                    </div>

                    @if (m.SwitchSignal) {
                    <div class="col-auto align-self-start">
                        <span class="badge badge-pill bg-positive-lighter text-success">
                            <i class="fa-sharp fa-solid fa-bolt me-1"></i> {{ texts.switchSignal | localize }}
                        </span>
                    </div>
                    }

                </div>
            </a>
        </div>
    </div>
</div>
}
